import { render } from "./CoursesListView.vue?vue&type=template&id=6d8b5287&scoped=true"
import script from "./CoursesListView.vue?vue&type=script&lang=js"
export * from "./CoursesListView.vue?vue&type=script&lang=js"

import "./CoursesListView.vue?vue&type=style&index=0&id=6d8b5287&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8b5287"]])

export default __exports__